import React from "react";

const OnlineAndMedicalCentreCombinedIcon = () => {
  return (
    <svg
      width="38"
      height="39"
      viewBox="0 0 38 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.6925 29.953H21.6925C22.2646 29.953 22.7442 29.7782 23.1312 29.4286C23.5179 29.0789 23.7113 28.6458 23.7113 28.129V25.3499L28.5194 27.634V19.5919L23.7113 21.8759V19.0968C23.7113 18.5801 23.5179 18.1469 23.1312 17.7973C22.7442 17.4476 22.2646 17.2728 21.6925 17.2728H11.6925C11.1204 17.2728 10.6408 17.4476 10.2537 17.7973C9.86667 18.1469 9.67312 18.5801 9.67312 19.0968V28.129C9.67312 28.6458 9.86667 29.0789 10.2537 29.4286C10.6408 29.7782 11.1204 29.953 11.6925 29.953ZM0.25 38.2903V12.8871L19 0.164032L37.75 12.8871V38.2903H0.25ZM4 34.9032H34V14.5806L19 4.41936L4 14.5806V34.9032Z"
        fill="#03579E"
      />
    </svg>
  );
};

export default OnlineAndMedicalCentreCombinedIcon;
